// app/pages/NotFoundPage.tsx
// BrightPath 404 Page

import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-cream-50 flex items-center justify-center px-4">
      <div className="max-w-md text-center">
        {/* Icon */}
        <div className="w-24 h-24 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-8">
          <svg
            className="w-12 h-12 text-sage-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Content */}
        <h1 className="text-6xl font-display font-bold text-navy-900 mb-4">
          404
        </h1>
        <h2 className="text-2xl font-semibold text-navy-800 mb-4">
          Page Not Found
        </h2>
        <p className="text-navy-600 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have been
          moved or doesn't exist.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="bg-sage-600 text-white px-6 py-3 rounded-lg hover:bg-sage-700 font-medium w-full sm:w-auto"
          >
            Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="border-2 border-navy-300 text-navy-700 px-6 py-3 rounded-lg hover:border-navy-400 font-medium w-full sm:w-auto"
          >
            Go Back
          </button>
        </div>

        {/* Help Links */}
        <div className="mt-12 pt-8 border-t border-cream-200">
          <p className="text-navy-500 text-sm mb-4">Looking for something?</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/resources" className="text-sage-600 hover:text-sage-700">
              Resources
            </Link>
            <Link to="/marketplace" className="text-sage-600 hover:text-sage-700">
              Marketplace
            </Link>
            <Link to="/login" className="text-sage-600 hover:text-sage-700">
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}